import * as React from "react";
import { joinClasses } from "../../../utils/Filters";
import { ensure } from "../../../utils/Optional";
import { asThemeConsumer } from "../../../theme/Theme";
import { RTE } from "../07-organisms/RTE";
/**
 *
 * @param props
 */
var TextAreaComp = function (props) {
    var clazzName = joinClasses(props.className, "scl-a-textarea__field", props.asSummary ? "scl-a-textarea__field--as-summary-textarea" : "");
    var onChange = !!props.onChange
        ? function (evt) {
            evt.preventDefault();
            ensure(props.onChange)(evt.target.value || undefined);
        }
        : undefined;
    return (props.asSummary ? (React.createElement("div", { className: clazzName, style: { height: "auto" } },
        React.createElement(RTE, { content: props.value || "", raw: props.raw })))
        : (React.createElement("textarea", { style: props.style, className: clazzName, placeholder: props.placeholder, readOnly: !onChange, value: props.value || "", onChange: onChange, disabled: props.disabled, required: props.required, maxLength: props.max })));
};
/**
 *
 */
export var TextArea = asThemeConsumer(TextAreaComp);
